import {
  ICheckBoxesAgrupados,
  ICheckBoxAgrupado,
  ICheckBoxesAgrupadosSecao,
  ICheckBoxesAgrupadosSecoes
} from 'src/tipos'

/**
 * Percorre opções de check boxes agrupados setando os valores conforme presença em uma lista de string
 * @param listaDeOpcoesSelecionada Uma lista de strings contendo as chaves selecionáveis
 * @param opcoesIniciais Um objeto contendo opções válidas para check boxes agrupados
 * @returns O mesmo objeto das opções iniciais, porém com os boleanos de cada item alterados conforme a presença na lista de seleções
 */
export function formatarOpcoesCheckBoxesAgrupados (
  listaDeOpcoesSelecionada: Array<string>,
  opcoesIniciais: ICheckBoxesAgrupados
): ICheckBoxesAgrupados {
  function formatarChecandoValorDeAcordoComEstadoDaSelecao (
    acumulador: ICheckBoxesAgrupados,
    opcaoAtual: [string, ICheckBoxAgrupado]
  ): ICheckBoxesAgrupados {
    const [chave, configuracao] = opcaoAtual
    configuracao.valor = listaDeOpcoesSelecionada.includes(chave as string)
    acumulador[chave] = configuracao
    return acumulador
  }

  const opcoesFormatadas = Object.entries(opcoesIniciais).reduce(formatarChecandoValorDeAcordoComEstadoDaSelecao, {} as ICheckBoxesAgrupados)
  return opcoesFormatadas
}

/**
 * Mapeia uma lista com todas as opções que foram marcadas. Recebe como parâmetro um objeto em que cada chave é um valor
 * válido para o back-end e objeto nessa chave é a configuração de exibição do check box juntamente com o boleano que é
 * alterado quando o check box tem seu estado alterado.
 * @param opcoes objeto contendo objetos em que a chave representa uma opção e o valor é a configuração de exibição do check box
 * @returns Uma lista contendo todas as chaves onde o valor seja true
 */
export function resgatarListaDeChavesDosCheckBoxesAgrupados (opcoes: ICheckBoxesAgrupados): string[] {
  function resgatarChaveSeOpcaoFoiMarcada (acumulador: string[], opcaoItem: [string, ICheckBoxAgrupado]): string[] {
    const [chave, condiguracao] = opcaoItem
    if (condiguracao.valor) {
      acumulador = [...acumulador, chave]
    }
    return acumulador
  }

  const listaDeChavesMarcadas = Object.entries(opcoes).reduce(resgatarChaveSeOpcaoFoiMarcada, [] as string[])
  return listaDeChavesMarcadas
}

/**
 * Mapeia uma lista com todas as opções que foram marcadas em um conjunto de grupos de check boxes.
 * Recebe como parâmetro um objeto em que cada chave representa uma seção, que tem legenda e um grupo de check boxes.
 * @param opcoes objeto contendo objetos em que cada chave representa uma seção, que possui legenda e um grupo de check boxes
 * @returns Uma lista contendo todas as chaves onde o valor seja true
 */
export function resgatarListaDeChavesDosCheckBoxesAgrupadosPorSecao (opcoes: ICheckBoxesAgrupadosSecoes): string[] {
  const listaDeOpcoesSelecionadaSecoes = Object.entries(opcoes).reduce((
    acumulador: string[],
    opcaoAtual: [string, ICheckBoxesAgrupadosSecao]
  ) => {
    const [, configuracao] = opcaoAtual
    const listaDeOpcoesSelecionada = resgatarListaDeChavesDosCheckBoxesAgrupados(configuracao.opcoes)
    acumulador = [...new Set([...acumulador, ...listaDeOpcoesSelecionada])]
    return acumulador
  }, [] as string[])
  return listaDeOpcoesSelecionadaSecoes
}
